import * as React from 'react'
import createSvgIcon from './createSvgIcon'
import styled from 'styled-components/macro'

const FlameIcon = createSvgIcon(
  <React.Fragment>
    <path d="M10.2938 2.00045C10.2938 1.12046 11.3501 0.668822 11.9861 1.2778C13.9441 3.15371 15.0819 7.27296 13.7361 10.3979L13.6561 10.5727L13.6678 10.5756C14.2927 10.7086 14.8706 10.1447 15.9705 8.40182L16.1111 8.17819C16.1923 8.04767 16.3019 7.93699 16.4324 7.85592C16.5631 7.77482 16.711 7.72521 16.8641 7.71041C17.0171 7.69564 17.1715 7.71641 17.3152 7.77096C17.459 7.82554 17.5885 7.91225 17.6932 8.02487C19.0272 9.45987 20.2938 12.4024 20.2938 14.2954C20.2937 17.5986 18.1388 20.4048 15.119 21.5034C14.0626 15.26 11.4288 14.6429 10.9998 18.0747C10.8845 18.9973 10.4329 20.3028 9.82404 21.6235C6.61912 20.6221 4.29384 17.7267 4.29376 14.2944C4.29376 12.0425 5.31576 9.57863 6.9256 7.99362L7.53107 7.40377C7.77189 7.16794 7.96533 6.97365 8.14923 6.77975C9.57887 5.26799 10.2937 3.85614 10.2938 2.00045Z" />
  </React.Fragment>,
  'Flame'
)

export default styled(FlameIcon)`
  path {
    transform: translateY(3px);
  }
`
